const state = () => {
    return {
        englishLocale: {
            linkIconAltText: "External link icon",
        },
        spanishLocale: {
            linkIconAltText: "Icono de enlace externo",
        }
    }
}

const getters = {
    linkWidgetLocale: (state, rootGetters) => {
        return rootGetters.useSpanishLocale
            ? state.spanishLocale
            : state.englishLocale;
    },
};

const actions = {};

const mutations = {};

export default {
    state,
    getters,
    actions,
    mutations,
};
